import { byViewport, useViewport } from '@/hooks/use-viewport';
import { fontSans, makePalette } from '@/lib/theme';

export function ScreenLoading({
  dark,
  label = 'Carregando…',
}: Readonly<{ dark: boolean; label?: string }>) {
  const p = makePalette(dark);
  const vp = useViewport();
  return (
    <div
      style={{
        width: '100%',
        // `100dvh` no compacto: no celular a barra de endereço come parte de
        // `100vh`, e o spinner ficava centralizado abaixo da dobra real.
        // A variável já resolve o fallback de navegador sem `dvh` (ver
        // `globals.css`); `100dvh` direto deixaria a altura em `auto` lá.
        height: 'var(--app-vh)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Rótulos longos ("Carregando o acervo de documentos…") encostavam nas
        // duas bordas em 320px; a respiração lateral e o `wrap` deixam o texto
        // quebrar em duas linhas em vez de vazar.
        flexWrap: 'wrap',
        padding: byViewport(vp, { mobile: '0 20px', desktop: '0' }),
        gap: 12,
        background: p.bg,
        color: p.muted,
        fontFamily: fontSans,
        fontSize: byViewport(vp, { mobile: 13.5, desktop: 13 }),
        textAlign: 'center',
      }}
    >
      <span
        style={{
          width: 16,
          height: 16,
          border: `2px solid ${p.border}`,
          borderTopColor: p.text,
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          // Sem isso o círculo era achatado pelo flex quando o rótulo empurrava.
          flexShrink: 0,
        }}
      />
      {/* O rótulo em <span> (e não texto solto) para poder encolher: item de flex
          anônimo não aceita `minWidth: 0` e estourava a linha. */}
      <span style={{ minWidth: 0 }}>{label}</span>
    </div>
  );
}
